<p-dialog [(visible)]="visible" appendTo="body" [modal]="!deviceManager.isMobile" [closable]="true" [showHeader]="true" (onHide)="onHide()"
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          styleClass="select-album-dialog">
    <p-header>Select Album</p-header>
    <div class="select-album-dialog-content">
        <p-tree [value]="albums" selectionMode="single" [loading]="loading" [style]="{ 'width': '100%' }"
                (onNodeSelect)="onAlbumSelected($event.node)" (onNodeExpand)="onAlbumExpanded($event.node)">
            <ng-template let-node pTemplate="default">
                <div class="album-tree-node-content" [class.selected]="selectedAlbumNode && selectedAlbumNode.data.Id === node.data.Id">
                    <mycampapp-image-asset #image [imageAsset]="node.data.Thumbnail" [width]="50" [height]="50" [usePlaceholder]="true"
                                           style="display: inline-block;"></mycampapp-image-asset>
                    <span class="album-label-text">{{node.label}}</span>
                </div>
            </ng-template>
        </p-tree>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" class="ok-button" label="Use Selected Album" icon="pi pi-check" (click)="onOk()" [disabled]="!selectedAlbumNode"></button>
    </ng-template>
</p-dialog>
